export function getFormattedDate (dateString: string) {
    const date = new Date(dateString);
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');
    return month + '/' + day + '/' + year;
    // return date.toLocaleDateString()
}

export function getFormattedDateUserReadable (dateString: string) {
    const date = new Date(dateString);
    return date.toDateString();
}
